import React from "react";
import "../ui/ui.scss";

/**
 * StatMetric — Compact stat card with icon, value, label, optional progress bar, and decorative circle.
 *
 * Props:
 *   icon       — React node (e.g. <FaTarget size={18} />)
 *   color      — blue | emerald | violet | amber | rose
 *   value      — Display value (string or number)
 *   suffix     — Appended after value in smaller text (e.g. "/10")
 *   label      — Description label below value
 *   progress   — 0-100, if provided shows a thin progress bar
 *   extra      — React node rendered below the label (badges, mini charts, etc.)
 *   className  — Extra class
 */
const StatMetric = ({ icon, color = "blue", value, suffix, label, progress, extra, className = "" }) => (
  <div className={`ui-card ui-stat ${className}`}>
    <div className={`ui-stat__decorator ui-stat__decorator--${color}`} />
    <div className="ui-card__body ui-stat__body">
      {icon && <div className={`ui-stat__icon ui-stat__icon--${color}`}>{icon}</div>}
      <div className="ui-stat__value">
        {value}
        {suffix && <span className="ui-stat__value-suffix">{suffix}</span>}
      </div>
      {label && <div className="ui-stat__label">{label}</div>}
      {progress !== undefined && (
        <div className="ui-stat__progress">
          <div className={`ui-progress ui-progress--sm`}>
            <div
              className={`ui-progress__fill ui-progress__fill--${color}`}
              style={{ width: `${Math.min(Math.max(progress, 0), 100)}%` }}
            />
          </div>
        </div>
      )}
      {extra && <div className="ui-stat__extra">{extra}</div>}
    </div>
  </div>
);

export default StatMetric;
